// Compare meaning rather than keystrokes; stable IDs retain split-row identity.
// An empty field stays distinct from an explicitly typed "0", so typing 0 into an
// empty cell is a change that can be saved, and clearing it again is clean.
export function hourRowsSnapshot(rows) {
    return JSON.stringify(rows.map(row => {
        const hours = String(row.hours ?? '').trim();
        return { id: row.persistedId || row.id, date: row.date.slice(0, 10), type: row.assignmentReasonId,
            hours: hours === '' ? '' : /^\d+$/.test(hours) ? Number(hours) : hours };
    }).sort((a, b) => `${a.date}/${a.id}`.localeCompare(`${b.date}/${b.id}`)));
}
